import { TableSizes } from '~/common/constants/sizing';
import { SizesValues } from '~/types/sizings';

export const buildRows = ({ sizeChartType, sizes }: TableSizes) => {
  const sizeLabels: Record<keyof SizesValues, string> = {
    fullLength: 'FULL LENGTH (CM)',
    chest: '1/2 CHEST (CM)',
    underarmChest: '1/2 UNDERARM CHEST (CM)',
    shoulder: 'SHOULDER (CM)',
    shoulders: 'SHOULDER WIDTH (CM)',
    sleeveLength: 'SLEEVE LENGTH (CM)',
    sleeveWidth: '1/2 SLEEVE WIDTH (CM)',
    centreLength: 'CENTER FRONT LENGTH (CM)',
    frontLength: 'FRONT LENGTH (CM)',
    hem: '1/2 HEM (CM)',
    hemWidth: '1/2 HEM WIDTH (CM)',
    waist: '1/2 WAIST (CM)',
    thigh: '1/2 THIGH (CM)',
    inseam: 'INSEAM LENGTH (CM)',
    hip: '1/2 HIP (CM)',
    headFlat: '1/2 HEAD FLAT (CM)',
    height: 'HEIGHT (CM)',
    turnOver: 'TURN OVER (CM)',
    ribbedHem: 'RIBBED HEM (CM)',
    shouldersWidth: 'SHOULDERS WIDTH (CM)',
    length: 'LENGTH (CM)',
    lengthInWaist: 'LENGTH IN WAIST (CM)',
    topCupHeight: 'BIKINI TOP CUP HEIGHT (CM)',
    bottomFrontWidth: 'BIKINI BOTTOM FRONT WIDTH (CM)',
    bottomFrontHeight: 'BIKINI BOTTOM FRONT HEIGHT (CM)',
    gussetWidth: 'GUSSET WIDTH (CM)',
    frontLegHem: 'FRONT LEG HEM (CM)',
    sideSeam: 'SIDE SEAM (CM)',
    sleeveLengthFromNeck: 'SLEEVE LENGTH from neck (CM)',
    sleeveLengthFromNeckline: 'SLEEVE LENGTH FROM NECKLINE (CM)',
    sleeveOpening: '1/2 SLEEVE OPENING (CM)',
    legHem: '1/2 LEG HEM (CM)',
    bodyLength: 'FULL LENGTH (CM)',
    fullWaist: 'FULL WAIST (CM)',
    frontLengthHSP: 'FRONT LENGTH (HSP) (CM)',
    frontLengthIncWaist: 'FRONT LENGTH INC. WAIST (CM)',
    lengthHSP: 'LENGTH HSP (CM)',
    lengthFromHSP: 'LENGTH FROM HSP (CM)',
    neckWidth: 'NECK WIDTH (CM)',
    lengthCF: 'CF LENGTH (CM)',
    lengthIncWaist: 'LENGTH INC WAIST (CM)',
    lengthWidthWaistband: '1/2 LENGTH INCL WAISTBAND (CM)',
    insideLeg: 'INSIDE LEG ',
    lengthFromHNP: 'LENGTH FROM HNP (CM)',
    width: '1/2 WIDTH (CM)',
  };

  const rows = Object.entries(sizes).map(([key, value]) => {
    if (value) {
      return [(sizeLabels as Record<string, string>)[key], ...value];
    }
    return [];
  });

  return rows.filter((row) => row.length > 0);
};
